<script lang="ts">
	import LinkInValue from '../table/LinkInValue.svelte'
	import ShortIdValue from './ShortIdValue.svelte'
	import { CopyButton } from '@repo/ui'

	interface Props {
		id: string
		link?: string | null
	}

	let { id, link = null }: Props = $props()

	const visiblePartLength = 4
</script>

{#if id?.length > visiblePartLength * 2}
	<div class="flex items-center space-x-2">
		{#if link !== null}
			<LinkInValue href={link}>
				<ShortIdValue {id} {visiblePartLength} />
			</LinkInValue>
		{:else}
			<ShortIdValue {id} {visiblePartLength} />
		{/if}
		<CopyButton text={id} />
	</div>
{:else}
	{id || ''}
{/if}
